import { Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import { DropdownsOpenFactory } from '@shared/factories/dropdowns-open/dropdowns-open.factory';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { NgClass } from '@angular/common';
import { SpanTooltipComponent } from '../span-tooltip/span-tooltip.component';
import { SharedModule } from 'primeng/api';

@Component({
    selector: 'list-in-dropdown',
    templateUrl: './list-in-dropdown.component.html',
    standalone: true,
    imports: [OverlayPanelModule, SharedModule, SpanTooltipComponent, NgClass]
})
export class ListInDropdownComponent implements OnChanges {
  listInDropdown:any = {
    id: this.commonUtilsService.createId(),
    title: this.translate.instant('contacts.recipients')
  }
  constructor(private translate: AfTranslateFactory,
    private dropdownsOpenFactory: DropdownsOpenFactory,
    private commonUtilsService: CommonUtilsService) { }
  @Input() list: any = [];
  @Input() type: any = null;
  @Input() iconType: string = 'confidential';
  @Input() patternId: any = null;
  @Input() subtitle: string = '';
  @ViewChild(OverlayPanel) dropdown: OverlayPanel;

  ngOnChanges(changes: SimpleChanges): void {
    this.configureContainer();
  }

  configureContainer(){
    switch(this.type){
      case 'alert':
        this.listInDropdown.title = this.translate.instant('participants-list.share-alert');
        break;
      case 'confidential':
      case 'confidential-historic':
        this.listInDropdown.title = this.translate.instant('manage-confidential-modal.auth-users');
        break;
      case 'evaluation':
        this.listInDropdown.title = this.translate.instant('participants-list.share-evaluation');
        break;
      case 'groups':
        this.listInDropdown.title = this.translate.instant('users-admin.group-form.members');
        break;
      case 'task':
      case 'manager-concept-list':
        this.listInDropdown.title = this.translate.instant('participants-list.share-task');
        break;
      case 'meeting':
        this.listInDropdown.title = this.translate.instant('contacts.invitations');
        break;
      case 'organizations':
        this.listInDropdown.title = this.translate.instant('common.organizations');
        break;
      case 'roles':
        this.listInDropdown.title = this.translate.instant('common.assigned-roles');
        break;
      case 'share-document':
        this.listInDropdown.title = this.translate.instant('documentation-list.share-document');
        break;
      case 'videoconferences':
        this.listInDropdown.title = this.translate.instant('contacts.invitations');
        break;
      default:
        // 'task-process'
        this.listInDropdown.title = this.translate.instant('contacts.recipients');
        break;
    }
  }

  toggleMenu(e: any){
    // e.stopPropagation();
    let element = this.patternId?document.getElementById(this.patternId):undefined;
    this.commonUtilsService.toggleFilterOverlay(e, this.dropdown, 'overlay', element);
  }

  closeDropdown(e: any){
    // e.stopPropagation();
    this.dropdownsOpenFactory.closeDropdown();
  }
}
